<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="RAAS"
    >
        <rkm-form
            v-if="model"
            ref="Form"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.raas.origensPaciente"
                        :validations="validations.origemPaciente"
                        label="Origem do paciente"
                        show-default-option
                        text-field="nome"
                        v-model="model.origemPacienteId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.raas.destinosPaciente"
                        :validations="validations.destinoPaciente"
                        label="Destino do paciente"
                        show-default-option
                        text-field="nome"
                        v-model="model.destinoPacienteId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.raas.motivosSaidaPermanencia"
                        label="Motivo de saída/permanência"
                        show-default-option
                        text-field="nome"
                        v-model="model.motivoSaidaPermanenciaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.raas.carateresAtendimento"
                        label="Caráter do atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.caraterAtendimentoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!data.hasProcedimentoRaasQuePrecisaDeAutorizacao"
                        :validations="validations.numeroAutorizacao"
                        label="Número da autorização"
                        number
                        v-model="model.numeroAutorizacao"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :disabled="!data.hasProcedimentoRaasQuePrecisaDeClassificacao"
                        :options="data.form.raas.classificacoes"
                        label="Classificação"
                        show-default-option
                        text-field="nome"
                        v-model="model.classificacaoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="data.form.raas.locaisRealizacaoExame"
                        label="Local de realização do exame"
                        show-default-option
                        text-field="nome"
                        v-model="model.localRealizacaoExameId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                numeroAutorizacao: { max: 13 },
            }
        },
    },
    data: () => ({
        model: null
    }),
    methods: {
        open() {

            this.model = this.clone(this.data.model.raas)

            if (!this.model.saved && !this.model.motivoSaidaPermanenciaId) {

                this.model.motivoSaidaPermanenciaId = this.data.form.raas.motivoSaidaPermanenciaId
            }

            if (!this.model.hadProcedimentoQuePrecisaDeClassificacao
                && this.data.hasProcedimentoRaasQuePrecisaDeClassificacao
                && !this.model.classificacaoId
            ) {

                this.model.classificacaoId = this.data.form.raas.classificacaoId
            }

            if (!this.model.hadProcedimentoQuePrecisaDeAutorizacao
                && this.data.hasProcedimentoRaasQuePrecisaDeAutorizacao
                && !this.model.numeroAutorizacao
            ) {

                this.model.numeroAutorizacao = this.data.form.raas.numeroAutorizacao
            }

            this.$refs.RkmModal.show()
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    const data = this.clone(this.model)

                    data.saved = true
                    data.hadProcedimentoQuePrecisaDeClassificacao = this.data.hasProcedimentoRaasQuePrecisaDeClassificacao
                    data.hadProcedimentoQuePrecisaDeAutorizacao = this.data.hasProcedimentoRaasQuePrecisaDeAutorizacao

                    this.data.model.raas = data

                    this.$refs.RkmModal.hide()
                })
        }
    },
    mixins: [object],
    props: {
        data: {type: Object, required: true},
    },
}
</script>